import { SVGProps } from 'react'

const MenuBurger = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="36"
    height="32"
    viewBox="0 0 36 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="6" y="8" width="24" height="2" rx="1" fill="currentColor" />
    <rect x="6" y="15" width="24" height="2" rx="1" fill="currentColor" />
    <rect x="6" y="22" width="24" height="2" rx="1" fill="currentColor" />
  </svg>
)

export default MenuBurger
